(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["storefront-chat"] && !Shopify.designMode) return;
  try {
    (() => {
    const init = () => {
    const root = document.querySelector('.sf-chat');
    if (!root) return;

    const panel = root.querySelector('#sf-chat-panel');
    const fab = root.querySelector('[data-sf-chat-open]');
    const closeBtn = root.querySelector('[data-sf-chat-close]');
    const startBtn = root.querySelector('[data-sf-chat-start]');
    const intro = root.querySelector('[data-sf-chat-intro]');
    const compose = root.querySelector('[data-sf-chat-compose]');
    const form = root.closest('form');
    const nameInput = root.querySelector('#sf-chat-name');
    const emailInput = root.querySelector('#sf-chat-email');
    const bodyInput = root.querySelector('#sf-chat-body');

    const setOpen = (open) => {
      root.classList.toggle('is-open', open);
      if (panel) panel.hidden = !open;
      if (fab) fab.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) {
        const step = root.getAttribute('data-step');
        const focusTarget =
          step === 'compose' ? bodyInput : step === 'success' ? closeBtn : nameInput;
        focusTarget?.focus?.();
      } else {
        fab?.focus?.();
      }
    };

    const showCompose = () => {
      if (nameInput && !nameInput.value.trim()) {
        nameInput.reportValidity();
        return;
      }
      if (emailInput && !emailInput.reportValidity()) return;
      root.setAttribute('data-step', 'compose');
      if (intro) intro.hidden = true;
      if (compose) compose.hidden = false;
      bodyInput?.focus?.();
    };

    fab?.addEventListener('click', () => setOpen(true));
    closeBtn?.addEventListener('click', () => setOpen(false));

    startBtn?.addEventListener('click', showCompose);

    form?.addEventListener('submit', (event) => {
      if (root.getAttribute('data-step') !== 'compose') {
        event.preventDefault();
        showCompose();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && root.classList.contains('is-open')) {
        setOpen(false);
      }
    });

    if (root.getAttribute('data-open-on-load') === 'true') {
      setOpen(true);
      if (root.getAttribute('data-step') === 'compose' && intro && compose) {
        intro.hidden = true;
        compose.hidden = false;
      }
    }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
